import React from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import situationsData from "./content/situations.json";
import differentiatorData from "./content/differentiators.json";
import benefitData from "./content/benefits.json";
import achievementsData from "./content/achievements.json";
import { showInParagraphs } from "./utils";
import SEOHelmet from "./SEOHelmet";

export default function Situation() {
  const { id } = useParams(); // Extract the ID from the URL

  // Create URL-friendly slug from title
  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const situationData = situationsData.find(
    (situation) => situation.title === id || createSlug(situation.title) === id
  );
  const differentiators = situationData.competitors_and_differentiators
    .split(",")
    .map((differentiator) => differentiator.trim());
  const benefits = situationData.benefits
    .split(",")
    .map((benefit) => benefit.trim());

  // for each of the differentiators, find the description
  const differentiatorDescriptions = differentiators.map((differentiator) => {
    const details = differentiatorData.find(
      (data) => data.title === differentiator
    );
    return details ? details : {title: "", description: ""};
  });
  // for each of the benefits, find the description
  const benefitDescriptions = benefits.map((benefit) => {
    const description = benefitData.find(
      (data) => data.title === benefit
    );
    return description ? description.description : "";
  });
  // achievements are relevant when they prove both one of this situation's
  // benefits and one of its differentiators
  const relevantAchievements = achievementsData.filter(
    (achievement) =>
      benefits.includes(achievement.proves_benefit?.trim()) &&
      differentiators.includes(achievement.proves_differentiator?.trim())
  );

  return (
    <>
      <SEOHelmet
        title={`${situationData.title} - Rick Molenaar`}
        description={situationData.description.substring(0, 160)}
        canonicalUrl={`https://rickmolenaar.me/hireme/${createSlug(situationData.title)}`}
      />
      <Container fluid className="bg-theme-primary">
        <Container>
          <Row>
            <Col>
              <img
                src={"../images/" + situationData.image}
                alt={situationData.title}
                className="service-hero-img mt-3 mb-4"
              />
              <h1 className="text-theme-accent1">{situationData.title}</h1>
              <div className="text-theme-accent3">
                {showInParagraphs(situationData.need)}
              </div>
              <div className="text-theme-accent3">
                {showInParagraphs(situationData.description)}
              </div>
              <strong className="text-theme-accent2">Benefits</strong>
              <ul className="text-theme-accent3">
                {benefits.map((benefit, index) =>
                  createListItem(index, benefit, benefitDescriptions[index])
                )}
              </ul>
              <strong className="text-theme-accent2">Why work with me</strong>
              <ul className="text-theme-accent3">
                {differentiators.map((differentiator, index) =>
                  createListItem(index, differentiatorDescriptions[index].title, differentiatorDescriptions[index].description)
                )}
              </ul>
              <strong className="text-theme-accent2">Proof</strong>
              <ul className="text-theme-accent3">
                {relevantAchievements.map((achievement, index) =>
                  createListItem(index, achievement.title, achievement.headline)
                )}
              </ul>
            </Col>
          </Row>
        </Container>
        <Row className="text-center">
          <Col className="mb-5">
            <a
              href={"/connect"}
              className="btn btn-primary mt-auto font-weight-bold"
            >
              Lets connect
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );

  function createListItem(index, title, description) {
    const paragraphs = description ? description.split("\n\n") : [""];
    return (
      <li key={index}>
        <strong>{title.trim()}</strong>:{" "}
        {paragraphs[0]}
        {paragraphs.slice(1).map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </li>
    );
  }
}
